/**
 * @file 临时埋点方法
 */
import {getParamsFromUrl} from '@baidu/map-fe-utils';

const {from: f, fr} = getParamsFromUrl();
const from = f || fr || 'default';

export function sendLog(actionID, payload = {}) {
    if (!window.MapLogReport || !actionID) {
        return;
    }

    window.MapLogReport.send({
        da_src: actionID,
        from,
        ...payload
    });
}
